import { Platform } from 'react-native';
import equal from 'fast-deep-equal';

export const isMobileNative = Platform.OS === 'ios' || Platform.OS === 'android';
export const objectsAreEquivalent = (a: object, b: object) => equal(a, b);

export const ICON_STROKE_WIDTH = 1.5;
export const MAX_LISTING_DUPLICATES = 20;
